export default __webpack_public_path__ + "static/media/hexagons-no-1.b1027ce3.mid";